import React from "react";
import { Box, Menu, MenuButton, MenuList, MenuItem, Icon, Flex } from "@chakra-ui/react";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import GradientButton from "components/Buttons/GradientButton";
import { FiDownload } from "react-icons/fi";
import { FolderInput } from "lucide-react";

const ExportButton = ({ data, fileName, ...props }) => {
  const exportToCSV = () => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${fileName}.csv`);
  };

  const exportToXLSX = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const dropdownItems = [
    {
      label: "Export to CSV",
      icon: FolderInput,
      onClick: exportToCSV,
    },
    {
      label: "Export to XLSX",
      icon: FolderInput,
      onClick: exportToXLSX,
    },
  ];

  return (
    <Box p={2}>
      <Menu>
        <MenuButton
          as={GradientButton}
          leftIcon={<FiDownload />}
          isDisabled={!data || data.length === 0}
          {...props}
        >
          Export
        </MenuButton>
        <Flex  position="relative"  mr={"5"} mt={"3"}>
        <MenuList minWidth="6=50px">
          {dropdownItems.map((item, index) => (
            <MenuItem key={index} onClick={item.onClick} fontSize="sm">
              <Icon as={item.icon} color="#071D54" mr={2} boxSize={5}/> {/* Icon color set here */}
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
        </Flex>
      </Menu>
    </Box>
  );
};

export default ExportButton;
